import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom"; // Use NavLink for active link styling
import image from "../img/logo5.png";
import "./Navigation.scss";
import "../Services/PatientCare/PatientCare";



const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false); // Mobile menu open state
  const [scrolled, setScrolled] = useState(false); // Sticky navbar on scroll

  // Handle scroll for sticky navbar
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) setScrolled(true);
      else setScrolled(false);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`navigation bg-white dark:bg-gray-900 fixed w-full z-20 top-0 border-b border-gray-200 dark:border-gray-600 ${
        scrolled ? "scrolled" : ""
      }`}
    >
      <div className="navbar flex items-center justify-between w-full p-4">
        {/* Logo */}
        <div className="logo flex items-center space-x-2">
          <img src={image} className="h-14 w-auto mt-2" alt="CareHealth Logo" />
        </div>

        {/* Navigation Menu */}
        <ul className="nav-menu hidden md:flex flex-1 justify-end items-center space-x-3">
          <li>
            <NavLink
              to="/"
              className={({ isActive }) => (isActive ? "menu-item active" : "menu-item")}
            >
              Home
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/About"
              className={({ isActive }) => (isActive ? "menu-item active" : "menu-item")}
            >
              About
            </NavLink>
          </li> 
          <li>
            <NavLink
              to="/Services"
              className={({ isActive }) => (isActive ? "menu-item active" : "menu-item")}
            >
              Services
            </NavLink>
            <div className="dropdown">
              <div className="content">
              <NavLink
                  to= "/Services/HomePatientCare"
                  className={({ isActive }) => (isActive ? "menu-item active" : "menu-item")}
                >
                  Home Patient care
                </NavLink>
               
                <NavLink to="/Services/NursingCare" className="menu-item">Nursing Care</NavLink>
                <div className="dropdown-1">
                  <NavLink to="/Services/HomeHealthCare" className="menu-item">Home Health Care</NavLink>
                  <NavLink to="/Services/ElderlyCare" className="menu-item">Elderly Care</NavLink>
                </div>
                <NavLink to="/Services/Physiotherapy" className="menu-item">Physiotherapy</NavLink>
            
                <NavLink to="/Services/MotherCare" className="menu-item">Mother Care</NavLink>
                <NavLink to="/Services/BabyCare" className="menu-item">Baby Care</NavLink>
                
              </div>
            </div>
          </li>
          <li>
            <NavLink
              to="/Gallery"
              className={({ isActive }) => (isActive ? "menu-item active" : "menu-item")}
            >
              Gallery
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/Contact"
              className={({ isActive }) => (isActive ? "menu-item active" : "menu-item")}
            >
              Contact
            </NavLink>
          </li>
          <li>
            <a
              href="tel:9999407473"
              className="menu-item bg-blue-700 text-white px-4 py-2 rounded hover:bg-blue-800"
            >
              Call Now
            </a>
            <div className="dropdown">
              <div className="content">
                <a href="#">Noida contact:no +919999407473 +919999320665                </a>
                <a href="#">Gurugram contact:no +919205981026 +919911337289</a>
                <a href="#">Delhi contact:no +919999407413 +919667462065  </a>
              </div>
            </div>
          </li>
        </ul>

        {/* Mobile Menu Toggle */}
        <button
          className="menu-toggle inline-flex items-center p-2 text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-700"
          onClick={() => setIsOpen(!isOpen)}
          aria-controls="navbar-sticky"
          aria-expanded={isOpen}
        >
          <span className="sr-only">Open main menu</span>
          <svg
            className="w-6 h-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h16M4 12h16m-7 6h7"
            />
          </svg>
        </button>

        {/* Mobile Menu */}
        <div
          className={`mobile-menu md:hidden bg-gray-50 dark:bg-gray-800 ${
            isOpen ? "open" : "hidden"
          } transition-all duration-300`}
        >
          <ul className="flex flex-col space-y-4 mt-4 text-gray-900 dark:text-white p-4 rounded-md">
            <li>
              <NavLink
                to="/"
                className={({ isActive }) => (isActive ? "menu-item active" : "menu-item")}
                onClick={() => setIsOpen(false)}
              >
                Home
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/About"
                className={({ isActive }) => (isActive ? "menu-item active" : "menu-item")}
                onClick={() => setIsOpen(false)}
              >
                About
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/Services"
                className={({ isActive }) => (isActive ? "menu-item active" : "menu-item")}
                onClick={() => setIsOpen(false)}
              >
                Services
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/Gallery"
                className={({ isActive }) => (isActive ? "menu-item active" : "menu-item")}
                onClick={() => setIsOpen(false)}
              >
                Gallery
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/Contact"
                className={({ isActive }) => (isActive ? "menu-item active" : "menu-item")}
                onClick={() => setIsOpen(false)}
              >
                Contact
              </NavLink>
            </li>
            <li>
              <a
                href="tel:9999407473"
                className="menu-item bg-blue-700 text-white px-4 py-2 rounded hover:bg-blue-800"
              >
                Call Now
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;